<script>
import DataBrick from '@/V2/analytics/DataBrick';
import { getCustomerFraudRatingProperties } from '@/utils/customerFraudRating';
import { getAndSyncQueryParams } from '@/utils/queryParams';

export default {
  components: { DataBrick },
  props: {
    data: {
      type: Array,
      default: null,
    },
    total: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      title: 'Customer Fraud Rating',
      subtitle: 'Breakdown of customer fraud ratings',
      roundToDecimalPlaces: 0,
    };
  },
  computed: {
    bricks() {
      return this.data.map((d, idx) => {
        const properties = getCustomerFraudRatingProperties(d.rating);
        const percentage = this.total === 0 ? 0 : (d.count / this.total) * 100;

        return {
          id: idx,
          title: properties.label,
          percentage: `${percentage.toFixed(this.roundToDecimalPlaces)}%`,
          count: d.count,
          type: d.rating,
          color: properties.iconColor,
          iconBackgroundColor: properties.iconBackgroundColor,
          icon: properties.icon,
        };
      });
    },
  },
  methods: {
    onBrickClicked(brick) {
      const currentQueryParams = getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      });

      const customersParams =
        this.convertAnalyticsParamsToCustomersParams(currentQueryParams);

      this.$router.push({
        path: 'customers',
        query: Object.assign({}, customersParams, {
          fraudRating: brick.type,
          return_to: 'analytics',
        }),
      });
    },
    convertAnalyticsParamsToCustomersParams(analyticsParams) {
      const customersParams = {};

      if (analyticsParams.start_date && analyticsParams.end_date) {
        customersParams.startDate = analyticsParams.start_date;
        const endDate = new Date(analyticsParams.end_date);
        endDate.setDate(endDate.getDate() + 1);
        customersParams.endDate = endDate.toISOString().split('T')[0];
      }

      if (analyticsParams.customer_statuses) {
        customersParams.status = Array.isArray(
          analyticsParams.customer_statuses,
        )
          ? analyticsParams.customer_statuses.join(',')
          : analyticsParams.customer_statuses;
      }

      if (analyticsParams.tags) {
        customersParams.tag = Array.isArray(analyticsParams.tags)
          ? analyticsParams.tags.join(',')
          : analyticsParams.tags;
      }

      return customersParams;
    },
  },
};
</script>

<template>
  <div class="md chart-card d-flex flex-column i-radius-2xl">
    <div class="i-mb-8 header d-flex flex-column">
      <div class="title i-text-neutral-120 i-text-button-2">
        {{ title }}
      </div>
      <div v-if="subtitle" class="subtitle i-text-neutral-110 i-text-body-2">
        {{ subtitle }}
      </div>
    </div>

    <div class="chart-card__body d-flex flex-row align-items-center i-gap-6">
      <data-brick
        v-for="brick in bricks"
        :key="brick.id"
        :brick-data="brick"
        :clickable="brick.count > 0"
        entity="customer-fraud-ratings"
        :style="{ flexGrow: 1 }"
        size="lg"
        @brick-clicked="onBrickClicked(brick)"
      ></data-brick>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.chart-card {
  border: 1px solid $light-neutral-60;
  width: 100%;
  padding: map-get($increments, 10);

  &__body {
    height: 100%;
  }
}
</style>
